/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerContractFunnelDto } from './BorrowerContractFunnelDto';
import {
    BorrowerContractFunnelDtoFromJSON,
    BorrowerContractFunnelDtoFromJSONTyped,
    BorrowerContractFunnelDtoToJSON,
    BorrowerContractFunnelDtoToJSONTyped,
} from './BorrowerContractFunnelDto';

/**
 * 
 * @export
 * @interface GetBorrowerContractFunnelsResponse
 */
export interface GetBorrowerContractFunnelsResponse {
    /**
     * 
     * @type {Array<BorrowerContractFunnelDto>}
     * @memberof GetBorrowerContractFunnelsResponse
     */
    contractFunnels: Array<BorrowerContractFunnelDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBorrowerContractFunnelsResponse
     */
    warningMessages?: Array<string>;
}

/**
 * Check if a given object implements the GetBorrowerContractFunnelsResponse interface.
 */
export function instanceOfGetBorrowerContractFunnelsResponse(value: object): value is GetBorrowerContractFunnelsResponse {
    if (!('contractFunnels' in value) || value['contractFunnels'] === undefined) return false;
    return true;
}

export function GetBorrowerContractFunnelsResponseFromJSON(json: any): GetBorrowerContractFunnelsResponse {
    return GetBorrowerContractFunnelsResponseFromJSONTyped(json, false);
}

export function GetBorrowerContractFunnelsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBorrowerContractFunnelsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'contractFunnels': ((json['contractFunnels'] as Array<any>).map(BorrowerContractFunnelDtoFromJSON)),
        'warningMessages': json['warningMessages'] == null ? undefined : json['warningMessages'],
    };
}

export function GetBorrowerContractFunnelsResponseToJSON(json: any): GetBorrowerContractFunnelsResponse {
    return GetBorrowerContractFunnelsResponseToJSONTyped(json, false);
}

export function GetBorrowerContractFunnelsResponseToJSONTyped(value?: GetBorrowerContractFunnelsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contractFunnels': ((value['contractFunnels'] as Array<any>).map(BorrowerContractFunnelDtoToJSON)),
        'warningMessages': value['warningMessages'],
    };
}

